import { FlowNodeDialogComponent } from "./flow-node-dialog.component"
import { SendMessageDialogComponent } from "./send-message-dialog/send-message-dialog.component"

export interface LabelValue {
  label: string
  value: any
  dynamicVariable?: boolean
  pmsVariable?: boolean
  functionType?: string
}

export interface NodeContainer {
  name: string
  description: string
  typeName: string
  img: string
  typeCategory: string
  color?: string
}

export const FlowStartNodesList: NodeContainer[] = [
  // { COMMENTED OUT UNTIL WE ARE SURE IT WORKS AS INTENDED
  //   name: "One time",
  //   description: "Schedule a one time",
  //   img: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/1.svg",
  //   typeName: "",
  //   typeCategory: "Time",
  // },
  // {
  //   name: "Recurring",
  //   description: "Schedule a recurring journey.",
  //   img: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/clock_recurring.svg",
  //   typeName: "",
  //   typeCategory: "Time",
  // },
  {
    name: "Reservation Status",
    description: "Listen for a reservation status change",
    img: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Info/1.0/check.svg",
    typeName: "",
    typeCategory: "Time",
  },
  {
    name: "Guest interaction",
    description: "Listen for a specific guest action, behaviour or event.",
    img: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/avatar.svg",
    typeName: "",
    typeCategory: "Time",
  },
]

export const FlowNodesTypeName: NodeContainer[] = [
  {
    name: "Reservation created", //Booking Created
    description: "Listen for new reservations coming in.",
    img: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/suitcase.svg",
    typeName: "BookingCreated",
    typeCategory: "Reservation",
  },
  {
    name: "Pre checked-in", // "Aeroguest Checkin",
    description: "Listen for when guests completes check in with AeroGuest. This happens before guest is automatically checked in, in your property management system.",
    img: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/door_in.svg",
    typeName: "GuestPreCheckedin",
    typeCategory: "AeroGuest Journey",
  },
  {
    name: "Reservation cancelled", //Booking canceled
    description: "Listen for new reservations changed to cancelled.",
    img: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Info/1.0/cross.svg",
    typeName: "BookingCanceled",
    typeCategory: "Reservation",
  },
  {
    name: "Checked in", // "Booking Checkedin",
    description: "Listen for reservation being checked in, in your property management system.",
    img: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/door_in.svg",
    typeName: "BookingCheckedin",
    typeCategory: "Reservation",
  },
  {
    name: "Checked out", // "Booking Checkedout"
    description: "Listen for reservation being checked out, in your property management system.",
    img: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/door_out.svg",
    typeName: "BookingCheckedout",
    typeCategory: "AeroGuest Journey",
  },
  {
    name: "Audience signed",
    description: "Listen for reservation signing audience, after checking in.",
    img: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/door_out.svg",
    typeName: "SignedAudience",
    typeCategory: "AeroGuest Journey",
  },
  {
    name: "Signed registration card",
    description: "",
    img: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/pen.svg",
    typeName: "RegistrationSigned",
    typeCategory: "AeroGuest Journey",
  },
  {
    name: "Paid for the stay",
    description: "",
    img: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/card.svg",
    typeName: "PaidForCheckin",
    typeCategory: "AeroGuest Journey",
  },
  {
    name: "Request a room",
    description: "",
    img: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/RoomFeatures/double_bed.svg",
    typeName: "RoomRequestCreated",
    typeCategory: "AeroGuest Journey",
  },
  {
    name: "Request room was confirmed",
    description: "",
    img: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/RoomFeatures/double_bed.svg",
    typeName: "RoomRequestSuccess",
    typeCategory: "AeroGuest Journey",
  },
  {
    name: "Request room was rejected",
    description: "",
    img: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/RoomFeatures/double_bed.svg",
    typeName: "RoomRequestFailed",
    typeCategory: "AeroGuest Journey",
  },
  {
    name: "Left a review of the stay",
    description: "",
    img: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/star.svg",
    typeName: "LeftReview",
    typeCategory: "AeroGuest Journey",
  },
]

export const FlowNewNodesList: NodeContainer[] = [
  // {
  //   name: "Schedule",
  //   description: "Configure which days of the week/month and the time of the day the audience can proceed to the next node.",
  //   img: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/clock.svg",
  //   typeName: "",
  //   typeCategory: "Time",
  //   color: "#F0F6FF",
  // },
  {
    name: "Delay",
    description: "Configure a period of time, before the audience proceeds to the next node.",
    img: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/delay.svg",
    typeName: "",
    typeCategory: "Time",
    color: "#F0F6FF",
  },
  {
    name: "Wait for trigger",
    description: "Schedule when the audience can proceed according to data from the start trigger. Only possible if the start trigger contains data about future status changes.",
    img: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/clock.svg",
    typeName: "",
    typeCategory: "Time",
    color: "#F0F6FF",
  },
  {
    name: "If/else",
    description: "Split your audience according to a condition that must be met for them to continue.",
    img: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/if-else.svg",
    typeName: "",
    typeCategory: "Rules",
    color: "#FFF8E5",
  },
  // {
  //   name: "Splitter",
  //   description: "Add a percentage splitter to divide your audience into several pathways. Makes it possible to expose them to different content to easily test performance.",
  //   img: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/if-else_a-b.svg",
  //   typeName: "",
  //   typeCategory: "Rules",
  //   color: "#FFF8E5",
  // },
  {
    name: "Send message",
    description: "Configure which message to send.",
    img: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/envelope_flying.svg",
    typeName: "",
    typeCategory: "Action",
    color: "#F0FFF4",
  },
  {
    name: "Send payment link",
    description: "Configure an automatic Pay by Link.",
    img: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/card.svg",
    typeName: "",
    typeCategory: "Action",
    color: "#F0FFF4",
  },
  // {
  //   name: "Send internal notification",
  //   description: "Receive an internal notification on email when audience reach this node.",
  //   img: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/unread.svg",
  //   typeName: "",
  //   typeCategory: "Action",
  //   color: "#F0FFF4",
  // },
]

export const messageTypes: LabelValue[] = [
  { label: "Email", value: "EMAIL" },
  { label: "SMS", value: "SMS" },
  { label: "App message", value: "APPMESSAGE" },
]

export const keyTypesMap: LabelValue[] = [
  { label: "SaltoKSPinCode", value: "CreateSaltoKSPinCode" },
  { label: "GodoPinCode", value: "CreateGodoPinCode" },
  { label: "TesaPinCode", value: "CreateTesaPinCode" },
]
export const keyNameTypes: LabelValue[] = [
  { label: "SaltoKSPinCode", value: "Create key" },
  { label: "GodoPinCode", value: "Retrieve PIN code" },
  { label: "TesaPinCode", value: "Retrieve PIN code" },
]

export const nodeTypeMap: LabelValue[] = [
  { label: "Send Message: Email", value: "Send message" },
  { label: "Send Message: SMS", value: "Send message" },
  { label: "Send Message: App message", value: "Send message" },
  { label: "Send email", value: "Send message" },
  { label: "Send sms", value: "Send message" },
  { label: "Send appmessage", value: "Send message" },
  { label: "Wait for trigger", value: "Wait for trigger" },
  { label: "Reservation status", value: "reservation-status" },
  { label: "Guest interaction", value: "guest-interaction" },
  { label: "If/else", value: "If/else" },
  { label: "Recurring", value: "recurring-first-node" },
  { label: "One time", value: "one-time-first-node" },
  { label: "Delay", value: "Delay" },
  { label: "FlowPayByLink", value: "FlowPayByLink" },
]

export const nodeColorMap: LabelValue[] = [
  { label: "Reservation confirmed", value: "#DFDFDF" },
  { label: "Reservation status", value: "#DFDFDF" },
  { label: "Wait for trigger", value: "#DFDFDF" },
  { label: "Delay", value: "#70A8FF" },
  { label: "Recurring", value: "#70A8FF" },
  { label: "If/else", value: "#FFD67A" },
  { label: "Send email", value: "#4ABA96" },
  { label: "FlowPayByLink", value: "#4ABA96" },
]
export const ImgContainerColorMap: LabelValue[] = [
  { label: "Reservation confirmed", value: "#E4D7F3" },
  { label: "Reservation status", value: "#E4D7F3" },
  { label: "One time", value: "#E4D7F3" },
  { label: "Guest interaction", value: "#E4D7F3" },
  { label: "Wait for trigger", value: "#F0F6FF" },
  { label: "Delay", value: "#F0F6FF" },
  { label: "Recurring", value: "#E4D7F3" },
  { label: "If/else", value: "#FFF8E5" },
  { label: "Send Message: Email", value: "#F0FFF4" },
  { label: "Send Message: SMS", value: "#F0FFF4" },
  { label: "Send Message: App message", value: "#F0FFF4" },
  { label: "Create key", value: "#F0FFF4" },
  { label: "FlowPayByLink", value: "#F0FFF4" },
  { label: "Retrieve PIN code", value: "#F0FFF4" },
]
export const IconMap: LabelValue[] = [
  { label: "Reservation confirmed", value: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Info/1.0/check.svg" },
  { label: "Reservation status", value: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Info/1.0/check.svg" },
  { label: "Guest interaction", value: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/avatar.svg" },
  { label: "Wait for trigger", value: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/pause.svg" },
  { label: "One time", value: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/1.svg" },
  { label: "Delay", value: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/delay.svg" },
  { label: "Recurring", value: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/clock_recurring.svg" },
  { label: "If/else", value: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/if-else.svg" },
  { label: "Send Message: Email", value: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/envelope_flying.svg" },
  { label: "Send Message: SMS", value: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/envelope_flying.svg" },
  { label: "Send Message: App message", value: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/envelope_flying.svg" },
  { label: "Create key", value: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/key.svg" },
  { label: "FlowPayByLink", value: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/card.svg" },
  { label: "Retrieve PIN code", value: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/pin_code.svg" },
]

// export const ListenableEvents: LabelValue[] = [
//   { label: "Arrival date", value: "StartDate" },
//   { label: "Departure date", value: "EndDate" },
//   { label: "Reservation created", value: "Created" },
//   { label: "Reservation cancelled", value: "Canceled" },
//   { label: "Checked in", value: "Checkedin" },
//   { label: "Checked out", value: "Checkedout" },
//   { label: "No show", value: "NoShow" },
// ]

export const FilterableValues: LabelValue[] = [
  { label: "Arrival date", value: "StartDate" },
  { label: "Departure date", value: "EndDate" },
  { label: "Reservation status", value: "Reservation:Status" },
  //{ label: "Guest interaction", value: "GuestInteraction" },
]

export const ReservationStatuses: LabelValue[] = [
  { label: "Reservation created", value: "Created" },
  { label: "Pre checked-in", value: "PreCheckedin" },
  { label: "Checked in", value: "Checkedin" },
  { label: "Checked out", value: "Checkedout" },
  { label: "Reservation cancelled", value: "Canceled" },
  { label: "No show", value: "NoShow" },
]

export const newJourneyNodeTypeList: LabelValue[] = [
  { label: "All", value: "All" },
  { label: "Time", value: "Time" },
  { label: "Rules", value: "Rules" },
  { label: "Actions", value: "Action" },
]

export const startNodeTypeList: LabelValue[] = [
  { label: "All", value: "All" },
  { label: "Reservation", value: "Reservation" },
  // { label: "Guest interaction", value: "Guest interaction" },
  { label: "Arrival date", value: "Arrival date" },
  { label: "Departure date", value: "Departure date" },
]

export const upcomingTriggerList: LabelValue[] = [
  { label: "Arrival day", value: "StartDate" },
  { label: "Departure day", value: "EndDate" },
]
export const beforeAfterList: LabelValue[] = [
  { label: "Before", value: "Before" },
  { label: "After", value: "After" },
]

export const FirstFilter: LabelValue[] = [
  { label: "Reservation status", value: "Reservation status" },
  // { label: "Guest interaction", value: "Guest interaction" }, //TODO Plan to add guest interactions
  //{ label: "Arrival date", value: "Arrival date" },
  //{ label: "Departure date", value: "Departure date" },
]
export const ComparisonList: LabelValue[] = [
  { label: "is less than", value: "<" },
  { label: "is equal to or less than", value: "<=" },
  { label: "is equal to", value: "==" },
  { label: "is equal to or greater than", value: "=>" },
  { label: "is greater than", value: ">" },
]

export interface NodeFunctionBody {
  ChildBodies?: NodeFunctionBody[] //Refers to the functions that needs to be used for this function
  BodyDataType?: string //Check confluence communication FE
  BodyType: string //Check confluence communication FE
  BodyData: string //Check confluence communication FE
}
